const Cookies = {
    create(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}${days ? `; expires=${date.toGMTString()}` : ''}; path=/`; 
    },
    read(name) {
        const nameEQ = `${name}=`;
        for(let item of document.cookie.split(';')){
            while (item.charAt(0) === ' ') item = item.substring(1, item.length);
            if (item.indexOf(nameEQ) === 0) return item.substring(nameEQ.length, item.length); 
        }
        return null;
    },
    erase(name) {
        var hostname = document.location.hostname;
        if (hostname.indexOf('www.') === 0) hostname = hostname.substring(4);
        //hostname = hostname.substr(hostname.indexOf('.') + 1); //if subdomains
        document.cookie = `${name}=; domain=.${hostname}; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=`;
        document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
    },
    eraseUnused() {
        for (let checkbox of checkboxes) {
            !checkbox.checked && checkbox.dataset.cookies.split(',').forEach(val => cookie.erase(val));
        }
    },
};

export default Cookies;